export const HOST_MOD_CLASSNAME = function (modClassName: string) {
  return this._baseClass + '--' + modClassName;
};

export const CHECK_MOD_CLASSNAME = function (classMod: string) {
  const hostClassName: Function = HOST_MOD_CLASSNAME.bind(this);

  if (this[classMod]) {
    const oldClassIndex = this._classList.findIndex((x) => x.indexOf(classMod) > -1);

    const oldClass = this._classList[oldClassIndex];
    const newClass = hostClassName(`${classMod}-${this[classMod]}`);

    if (oldClass !== newClass) {
      if (oldClassIndex !== -1) {
        this._classList.splice(this._classList.indexOf(oldClass), 1);
      }
      this._classList.push(hostClassName(`${classMod}-${this[classMod]}`));
    }
  }
};
